<div class="left-modal">
	<div class="close" (click)="close()"></div>
	<div class="modal-container">
		<h1 >{{'Filter project' | translate}}</h1>
		<form #form="ngForm" (ngSubmit)="submitForm()" novalidate>
			<div class="L-12 M-12 S-12 columns">
				<label>{{'Production country' | translate}}**</label>
				<app-dropdown
					[(appModel)]="viewFilterData.productionCountry"
					[list]="lists.countries"
					[value]="'id'"
					[name]="'prod_center'"
					[backTranslate]="true"
					[multiple]="true"
				></app-dropdown>
			</div>
			<div class="L-12 M-12 S-12 columns">
				<label>{{'Project Statuses' | translate}}**</label>
				<app-dropdown
					[(appModel)]="viewFilterData.projectStatuses"
					[list]="lists.project_statuses"
					[value]="'id'"
					[name]="'name'"
					[backTranslate]="true"
					[multiple]="true"
				></app-dropdown>
			</div>
			<div class="L-12 M-12 S-12 columns TextCentered">
				<input name="sumbit" type="submit" value="{{'Filter' | translate}}">
			</div>
			<div class="L-12 M-12 S-12 columns TextCentered">
				<a class="button cancel" (click)="close()">{{'Cancel' | translate}}</a>
			</div>
		</form>
	</div>
</div>
